import React from 'react';
import { Link } from 'react-router';

const StatusBadge = ({ status }) => {
  const statusConfig = {
    PENDING: { color: '#f59e0b', bg: '#fef3c7', text: 'Pending' },
    STARTED: { color: '#3b82f6', bg: '#dbeafe', text: 'Running' },
    READY: { color: '#10b981', bg: '#d1fae5', text: 'Ready' },
    FAILED: { color: '#ef4444', bg: '#fee2e2', text: 'Failed' },
  };

  const config = statusConfig[status] || { color: '#6b7280', bg: '#f3f4f6', text: status };

  return (
    <span
      className="px-3 py-1 rounded-full text-sm font-medium"
      style={{
        color: config.color,
        backgroundColor: config.bg
      }}
    >
      {config.text}
    </span>
  );
};

const JobCard = ({
  job,
  onClick,
  linkTo,
  title,
  linkColor = 'blue-600',
  linkHoverColor = 'blue-800',
  statusMessages = {},
  showDownload = false
}) => {
  const statusConfig = {
    PENDING: '#f59e0b',
    STARTED: '#3b82f6',
    READY: '#10b981',
    FAILED: '#ef4444',
  };

  const statusColor = statusConfig[job.status] || '#6b7280';

  const getStatusMessage = () => {
    if (statusMessages[job.status]) {
      return statusMessages[job.status];
    }

    // Default messages
    const defaultMessages = {
      PENDING: 'Waiting to start',
      STARTED: 'Processing...',
      READY: 'Ready',
      FAILED: 'Processing failed'
    };

    return defaultMessages[job.status] || job.status;
  };

  return (
    <div
      className="relative bg-white rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all duration-200 cursor-pointer group overflow-hidden"
      onClick={onClick}
    >
      {/* Status color bar on the right */}
      <div
        className="absolute top-0 right-0 w-1 h-full"
        style={{ backgroundColor: statusColor }}
      />

      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <Link
              to={linkTo}
              onClick={(e) => e.stopPropagation()}
              className={`text-lg font-semibold text-${linkColor} hover:text-${linkHoverColor} transition-colors`}
            >
              {title}
            </Link>
            <p className="text-sm text-gray-600 mt-1">
              Created by {job.username}
            </p>
          </div>
          <StatusBadge status={job.status} />
        </div>

        {/* Dates - hidden on small screens */}
        <div className="hidden md:flex text-xs text-gray-500 space-x-4 mb-4">
          <span>Created: {new Date(job.created_at).toLocaleDateString()}</span>
          <span>Updated: {new Date(job.updated_at).toLocaleDateString()}</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: statusColor }} />
            <span className="text-sm text-gray-600">
              {getStatusMessage()}
            </span>
          </div>

          {showDownload && job.status === 'READY' && job.signed_url && (
            <a
              className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
              href={job.signed_url}
              target="_blank"
              rel="noreferrer"
              onClick={e => e.stopPropagation()}
            >
              <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobCard;
